if(window.location.href.includes("/products/")) //only execute for product page
{
    var timeValidated = false;
    var needsQmCalc = false;
    var qmCalcOnly = false;

    if(document.getElementById("button-validate-all")!=null){
        needsQmCalc = true;
    }
    if(document.getElementById("button-validate-time")!=null){
        //console.log("validate time");
        document.getElementById("button-validate-time").onclick = function() {onValidateButtonKlicked()};
    }
    if(document.getElementById("button-validate-time")==null && document.getElementById("button-validate-all")==null && document.getElementById("button-validate-qm")==null )
    {
        timeValidated = true; //setting to true, because we need no additional checks
    }
    if(document.getElementById("button-validate-qm")!=null){
        //console.log("validate qm only");
        qmCalcOnly = true;
        document.getElementById("button-validate-qm").style = "display: none";
        document.getElementById("product-form-input").style = "visibility: hidden; height: 0";
    }
    if(needsQmCalc && qmCalcOnly==false){
        //console.log("validate everything");
        document.getElementById("button-validate-all").onclick = function() {onValidateButtonKlicked()};
    }
    if(document.getElementById("qm")!=null){
        document.getElementById("qm").addEventListener("change", onQmInputChanged);

        function onQmInputChanged() {
            //console.log("input changed for qm");

            var quantityField = document.querySelectorAll('[id^="Quantity-template"]'); //getting input field for product amount

            for (const value of quantityField.values()) {
                if (qmCalcOnly == true) {
                    //console.log("setting: " + value.value + " to " + document.getElementById("qm").value);
                    value.value = document.getElementById("qm").value;
                    timeValidated = true; //setting to true, because we need no additional checks
                    document.getElementById("dateMessage").innerHTML = ""; //reset error message
                }
            }
        }
    }

    if(document.getElementById("product-form-submit")!=null){
        document.getElementById("product-form-submit").addEventListener('click', function(event){
            //console.log("product-form-submit klicked");
            if(!timeValidated){
                //console.log("adding to cart NOT allowed, prevent event");
                event.preventDefault();

                if(window.location.href.indexOf("/en") != -1){
                    document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Please input your data first and then validate!";
                }
                else{
                    document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Bitte zuerst Daten eingeben und validieren!";
                }
            }
            else{
                //console.log("adding to cart allowed");
            }
        });
    }


    //console.log("correct page loaded and onklick functions applied, timeValidated: " + timeValidated);

    //start handling product variants
    if(document.getElementById('product-variant-wrapper')!=null && document.getElementById('product-variant-wrapper').classList.contains("product-with-quantity-break")){
        document.getElementById('product-variant-wrapper').style.visibility="hidden";
      document.getElementById('product-variant-wrapper').style.position="absolute";

        var quantityInput = document.querySelector(".quantity__input");

        quantityInput.addEventListener("change", function(event) {
            //console.log("Input field value changed to: ", event.target.value);

            if(event.target.value <= 25){
                setVariantRadio(1);
            }
            if(event.target.value > 25 && event.target.value <= 50){
                setVariantRadio(2);
            }
            if(event.target.value > 50 && event.target.value <= 75){
                setVariantRadio(3);
            }
            if(event.target.value > 75){
                setVariantRadio(4);
            }
        });
    }
    //end handling product variants
}

function setVariantRadio(number){
    var staffelpreiseRadios = document.querySelectorAll('input[type="radio"][name="Preiskategorie"]');

    staffelpreiseRadios.forEach(function(radio) {
        //console.log("variant: " + number.toString() + " and: " + radio.value.toString());
        if(radio.value.toString().includes(number.toString())){
            //console.log("setting radio button with staffelpreis: " + number + " to checked");
            document.getElementById(radio.id).click();
        }
    });
}


function onValidateButtonKlicked() {
    //console.log("validate button klicked");

    var inputOk = true;

    if(qmCalcOnly==false){
        var startDate = new Date(document.getElementById("start-date").value);
        var endDate = new Date(document.getElementById("end-date").value);
        var startTime = document.getElementById("start-time").value;
        var endTime = document.getElementById("end-time").value;

        var hour;
        var min;
        hour = startTime.split(':')[0]; //get hour
        min = startTime.split(':')[1]; //get minutes
        startDate.setHours(hour, min, 0); //setting start date
        hour = endTime.split(':')[0]; //get hour
        min = endTime.split(':')[1]; //get minutes
        endDate.setHours(hour, min, 0); //setting end date

        //console.log("start date modified: " + startDate);
        //console.log("end date modified: " + endDate);

        var timeDiff = time_diff(endDate, startDate); //getting difference between start and enddate
        var timeDiffDays = time_diff_days(endDate, startDate); //getting difference between start and enddate in days

        if(timeDiff<240 && timeDiff>=0){ //minimum of 4 hours nedded (check in minutes)
            //console.log("time input: " + timeDiff + " too small");
            inputOk = false;

            if(window.location.href.indexOf("/en") != -1){
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Period invalid! Please select a minimum of 4 hours.";
            }
            else{
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Zeitraum ungültig! Bitte mindestens 4 Stunden auswählen.";
            }
        }
        if(timeDiff<0){ //start date must not be bigger than end date
            //console.log("start date is bigger than end date");
            inputOk = false;

            if(window.location.href.indexOf("/en") != -1){
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Period invalid! Start- has to be bigger than end date.";
            }
            else{
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Zeitraum ungültig! Start- muss größer sein als End-Datum.";
            }
        }
        if(startDate < new Date() || endDate < new Date()){ //check if input dates are in the past
            //console.log("start or enddate in the past -> not possible");
            inputOk = false;

            if(window.location.href.indexOf("/en") != -1){
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Period invalid! Please select date in future.";
            }
            else{
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Zeitraum ungültig! Bitte Datum in der Zukunft eingeben.";
            }
        }
    }

    if(needsQmCalc==true) //check if qm is needed
    {
        //console.log("qm calc needed with value: " + document.getElementById("qm").value);
        if(document.getElementById("qm").value=="" || document.getElementById("qm").value<=0) //check if input field has a value or is valid
        {
            //console.log("invalid input qm: " + document.getElementById("qm").value);
            inputOk = false;

            if(window.location.href.indexOf("/en") != -1){
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Quadratmeter ungültig! Bitte korrekte Daten eingeben.";
            }
            else{
                document.getElementById("dateMessage").innerHTML = "<span style='color: red;'>⚠</span> Square meters invalid! Please correct your input.";
            }
        }
    }
    if(inputOk){ //everything OK
        //console.log("input OK");
        if(qmCalcOnly==true){
            //console.log("qm only calc with: " + document.getElementById("qm").value);
        }
        else{
            var amountHalfHours = timeDiff/30;
            //console.log("time difference: " + timeDiff + " mins and amount in half-hours: " + amountHalfHours + " and in days: " + timeDiffDays);
            document.getElementById("dateMessage").innerHTML = ""; //reset error message if everything OK
        }

        var quantityField = document.querySelectorAll('[id^="Quantity-template"]'); //getting input field for product amount

        for (const value of quantityField.values()) {
            if(qmCalcOnly==true){
                //console.log("setting: " + value.value + " to " + document.getElementById("qm").value);
                value.value=document.getElementById("qm").value;
            }
            else{
                if(needsQmCalc==true){
                    value.value=document.getElementById("qm").value*timeDiffDays;
                }
                else{
                    value.value=amountHalfHours; //setting value in input field
                }
            }
        }

        timeValidated = true; //time successfully validated

        //disable +/- quantity elements, user must not change it manually
        const collection = document.getElementsByClassName("quantity__input");
        for (let i = 0; i < collection.length; i++) {
            collection[i].readOnly = true;
        }
        document.getElementById("quantityButtonMinus").disabled = true;
        document.getElementById("quantityButtonPlus").disabled = true;
    }
}

function onSubmitButtonKlicked(){
    //console.log("submit button klicked");
}

function time_diff(endDate, startDate)
{
    var diff =(endDate - startDate)/1000/60;

    return diff; //returns time difference in minutes
}
function time_diff_days(endDate, startDate)
{
    var diff =(endDate - startDate);

    return Math.ceil(diff / (1000 * 3600 * 24)); //returns time difference in days (rounded)
}